var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopulationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 4.5,
    fill: "#FBFBFC",
    stroke: "#843EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.588 39.3506C26.0415 39.3506 24.7877 40.6044 24.7877 42.1509C24.7877 43.6975 26.0415 44.9513 27.588 44.9513C29.1346 44.9513 30.3884 43.6975 30.3884 42.1509C30.3884 40.6044 29.1346 39.3506 27.588 39.3506ZM22.5475 42.1509C22.5475 39.3671 24.8042 37.1104 27.588 37.1104C30.3719 37.1104 32.6286 39.3671 32.6286 42.1509C32.6286 44.9348 30.3719 47.1915 27.588 47.1915C24.8042 47.1915 22.5475 44.9348 22.5475 42.1509Z",
    fill: "#843EF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0686 27.0292C30.522 27.0292 29.2682 28.2829 29.2682 29.8295C29.2682 31.3761 30.522 32.6298 32.0686 32.6298C33.6151 32.6298 34.8689 31.3761 34.8689 29.8295C34.8689 28.2829 33.6151 27.0292 32.0686 27.0292ZM27.028 29.8295C27.028 27.0457 29.2847 24.7889 32.0686 24.7889C34.8524 24.7889 37.1091 27.0457 37.1091 29.8295C37.1091 32.6134 34.8524 34.8701 32.0686 34.8701C29.2847 34.8701 27.028 32.6134 27.028 29.8295Z",
    fill: "#843EF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7471 29.2694C18.2006 29.2694 16.9468 30.5232 16.9468 32.0698C16.9468 33.6164 18.2006 34.8701 19.7471 34.8701C21.2937 34.8701 22.5475 33.6164 22.5475 32.0698C22.5475 30.5232 21.2937 29.2694 19.7471 29.2694ZM14.7065 32.0698C14.7065 29.2859 16.9633 27.0292 19.7471 27.0292C22.531 27.0292 24.7877 29.2859 24.7877 32.0698C24.7877 34.8536 22.531 37.1104 19.7471 37.1104C16.9633 37.1104 14.7065 34.8536 14.7065 32.0698Z",
    fill: "#843EF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.238 18.0682C38.6915 18.0682 37.4377 19.3219 37.4377 20.8685C37.4377 22.4151 38.6915 23.6688 40.238 23.6688C41.7846 23.6688 43.0384 22.4151 43.0384 20.8685C43.0384 19.3219 41.7846 18.0682 40.238 18.0682ZM35.1975 20.8685C35.1975 18.0846 37.4542 15.8279 40.238 15.8279C43.0219 15.8279 45.2786 18.0846 45.2786 20.8685C45.2786 23.6523 43.0219 25.9091 40.238 25.9091C37.4542 25.9091 35.1975 23.6523 35.1975 20.8685Z",
    fill: "#843EF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1497 34.8701C40.6031 34.8701 39.3494 36.1238 39.3494 37.6704C39.3494 39.217 40.6031 40.4707 42.1497 40.4707C43.6963 40.4707 44.95 39.217 44.95 37.6704C44.95 36.1238 43.6963 34.8701 42.1497 34.8701ZM37.1091 37.6704C37.1091 34.8866 39.3659 32.6298 42.1497 32.6298C44.9336 32.6298 47.1903 34.8866 47.1903 37.6704C47.1903 40.4543 44.9336 42.711 42.1497 42.711C39.3659 42.711 37.1091 40.4543 37.1091 37.6704Z",
    fill: "#843EF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4361 16.948C21.8895 16.948 20.6358 18.2018 20.6358 19.7483C20.6358 21.2949 21.8895 22.5487 23.4361 22.5487C24.9827 22.5487 26.2364 21.2949 26.2364 19.7483C26.2364 18.2018 24.9827 16.948 23.4361 16.948ZM18.3955 19.7483C18.3955 16.9645 20.6523 14.7078 23.4361 14.7078C26.2199 14.7078 28.4767 16.9645 28.4767 19.7483C28.4767 22.5322 26.2199 24.7889 23.4361 24.7889C20.6523 24.7889 18.3955 22.5322 18.3955 19.7483Z",
    fill: "#843EF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopulationIcon);
export default __webpack_public_path__ + "static/media/population-icon.10748e41fca8e5831e40901018b10f29.svg";
export { ForwardRef as ReactComponent };